// extracted by mini-css-extract-plugin
module.exports = {"urlText":"TagWithButton_urlText__BOP9P"};